/**
 * SPDX-FileCopyrightText: 2026 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */

import { loadState } from '@nextcloud/initial-state'

const hideTeamSharedFolderCreation = loadState('contacts', 'hideTeamSharedFolderCreation', false)
export default hideTeamSharedFolderCreation
